<script>
export default {
  name: 'EarnedPoints',
  components: {},
  props: {
    postPoints: {
      type: Number,
      required: true,
    },
    totalPoints: {
      type: Number,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<template>
  <BaseModalWindow
    modalcls="user-edit max-w-md bg-white rounded-xl mx-auto px-10 py-8 shadow-box relative left-0 overflow-hidden"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <h3 class="block italic font-brandon text-blue-darker text-35xl pb-6"
        >You earned Kynd Points</h3
      >
      <div
        class="border-t-2 border-b-2 border-gray-light py-8 flex justify-between"
      >
        <div class="">This post: {{ postPoints }}</div>
        <div class="">Your total: {{ totalPoints }}</div>
      </div>
      <div class="mx-auto text-center mt-4 flex justify-between">
        <button class="button secondary-button">Manage points</button>
        <router-link
          :to="{
            name: 'companyStore',
            params: { companyId: companyId },
          }"
          class="button secondary-button"
        >
          Spend points
        </router-link>
      </div>
    </template>
  </BaseModalWindow>
</template>
